import { render, staticRenderFns } from "./help6_2.vue?vue&type=template&id=65f64d0d&"
import script from "./help6_2.vue?vue&type=script&lang=js&"
export * from "./help6_2.vue?vue&type=script&lang=js&"
import style0 from "./help6_2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports